
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { FaBars, FaTimes } from "react-icons/fa";

// const Header = () => {
//   const [mobile, setMobile] = useState(window.innerWidth <= 768);
//   const [menuOpen, setMenuOpen] = useState(false);

//   /* Screen Resize */
//   useEffect(() => {
//     const handleResize = () => {
//       setMobile(window.innerWidth <= 768);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <header style={headerStyle}>
      
//       {/* Logo */}
//       <div>
//         <h2 style={logoStyle}>Statix trading</h2>
//       </div>

//       {/* Desktop Menu */}
//       {!mobile && (
//         <nav style={desktopMenu}>
//           <Link to="/" style={navLink}>
//             Home
//           </Link>

//           <Link to="/about" style={navLink}>
//             About
//           </Link>

//           <Link to="/contact" style={navLink}>
//             Contact
//           </Link>

//           <Link to="/privacy-policy" style={navLink}>
//             Privacy Policy
//           </Link>
//         </nav>
//       )}

//       {/* Mobile Menu Icon */}
//       {mobile && (
//         <div
//           style={menuIcon}
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           {menuOpen ? (
//             <FaTimes size={24} color="#fff" />
//           ) : (
//             <FaBars size={24} color="#fff" />
//           )}
//         </div>
//       )}

//       {/* Mobile Menu */}
//       {mobile && menuOpen && (
//         <div style={mobileMenu}>
//           <Link
//             to="/"
//             style={mobileNavLink}
//             onClick={() => setMenuOpen(false)}
//           >
//             Home
//           </Link>

//           <Link
//             to="/about"
//             style={mobileNavLink}
//             onClick={() => setMenuOpen(false)}
//           >
//             About
//           </Link>

//           <Link
//             to="/contact"
//             style={mobileNavLink}
//             onClick={() => setMenuOpen(false)}
//           >
//             Contact
//           </Link>

//           <Link
//             to="/privacy-policy"
//             style={mobileNavLink}
//             onClick={() => setMenuOpen(false)}
//           >
//             Privacy Policy
//           </Link>
//         </div>
//       )}
//     </header>
//   );
// };

// /* ================= Styles ================= */

// const headerStyle = {
//   background: "#0f172a",
//   padding: "15px 25px",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   position: "sticky",
//   top: 0,
//   zIndex: 1000,
// };

// const logoStyle = {
//   color: "#22c55e",
//   margin: 0,
//   fontSize: "28px",
//   fontWeight: "bold",
// };

// const desktopMenu = {
//   display: "flex",
//   gap: "25px",
//   alignItems: "center",
// };

// const navLink = {
//   color: "#ffffff",
//   textDecoration: "none",
//   fontSize: "16px",
//   fontWeight: "500",
// };

// const menuIcon = {
//   cursor: "pointer",
// };

// const mobileMenu = {
//   position: "absolute",
//   top: "70px",
//   left: 0,
//   width: "100%",
//   background: "#1e293b",
//   display: "flex",
//   flexDirection: "column",
//   padding: "20px",
//   gap: "20px",
//   boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
// };

// const mobileNavLink = {
//   color: "#fff",
//   textDecoration: "none",
//   fontSize: "18px",
//   fontWeight: "500",
// };

// export default Header;

import React, { useState, useEffect } from "react";
import {
  Link,
  useLocation,
} from "react-router-dom";
import logo from "../../Images/statix tradinglogo.png";


import {
  FaBars,
  FaTimes,
} from "react-icons/fa";

const Header = () => {

  const location = useLocation();

  const [mobile, setMobile] = useState(
    window.innerWidth <= 768
  );

  const [menuOpen, setMenuOpen] =
    useState(false);

  /* Screen Resize */
  useEffect(() => {

    const handleResize = () => {
      setMobile(window.innerWidth <= 768);
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };

  }, []);

  return (
    <header style={headerStyle}>

      {/* Logo */}
      {/* <div>
        <h2 style={logoStyle}>
          Statix Trading
        </h2>
      </div> */}
      {/* Logo */}
<div>
<img
  src={logo}
  alt="Statix Trading"
  style={{
    width: "180px",
    height: "200px",  
    objectFit: "contain",
    display: "block",
  }}
/>
</div>

      {/* Desktop Menu */}
      {!mobile && (
        <nav style={desktopMenu}>

          <Link
            to="/"
            style={{
              ...navLink,
              color:
                location.pathname === "/"
                  ? "#22c55e"
                  : "#ffffff",
            }}
          >
            Home
          </Link>

          <Link
            to="/about"
            style={{
              ...navLink,
              color:
                location.pathname ===
                "/about"
                  ? "#22c55e"
                  : "#ffffff",
            }}
          >
            About
          </Link>

          <Link
            to="/contact"
            style={{
              ...navLink,
              color:
                location.pathname ===
                "/contact"
                  ? "#22c55e"
                  : "#ffffff",
            }}
          >
            Contact
          </Link>

          <Link
            to="/privacy-policy"
            style={{
              ...navLink,
              color:
                location.pathname ===
                "/privacy-policy"
                  ? "#22c55e"
                  : "#ffffff",
            }}
          >
            Privacy Policy
          </Link>

        </nav>
      )}

      {/* Mobile Menu Icon */}
      {mobile && (
        <div
          style={menuIcon}
          onClick={() =>
            setMenuOpen(!menuOpen)
          }
        >
          {menuOpen ? (
            <FaTimes
              size={24}
              color="#fff"
            />
          ) : (
            <FaBars
              size={24}
              color="#fff"
            />
          )}
        </div>
      )}

      {/* Mobile Menu */}
      {mobile && menuOpen && (
        <div style={mobileMenu}>

          <Link
            to="/"
            style={{
              ...mobileNavLink,
              color:
                location.pathname === "/"
                  ? "#22c55e"
                  : "#ffffff",
            }}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            Home
          </Link>

          <Link
            to="/about"
            style={{
              ...mobileNavLink,
              color:
                location.pathname ===
                "/about"
                  ? "#22c55e"
                  : "#ffffff",
            }}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            About
          </Link>

          <Link
            to="/contact"
            style={{
              ...mobileNavLink,
              color:
                location.pathname ===
                "/contact"
                  ? "#22c55e"
                  : "#ffffff",
            }}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            Contact
          </Link>

          <Link
            to="/privacy-policy"
            style={{
              ...mobileNavLink,
              color:
                location.pathname ===
                "/privacy-policy"
                  ? "#22c55e"
                  : "#ffffff",
            }}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            Privacy Policy
          </Link>

        </div>
      )}

    </header>
  );
};

/* ================= Styles ================= */

// const headerStyle = {
//   background: "#0f172a",
//   padding: "15px 25px",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   position: "sticky",
//   top: 0,
//   zIndex: 1000,
// };
const headerStyle = {
  background: "#0f172a",
  padding: "8px 18px",  
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  height: "85px",        
};

const logoStyle = {
  color: "#22c55e",
  margin: 0,
  fontSize: "28px",
  fontWeight: "bold",
};

const desktopMenu = {
  display: "flex",
  gap: "25px",
  alignItems: "center",
};

const navLink = {
  textDecoration: "none",
  fontSize: "16px",
  fontWeight: "500",
  transition: "0.3s",
};

const menuIcon = {
  cursor: "pointer",
};

const mobileMenu = {
  position: "absolute",
  top: "70px",
  left: 0,
  width: "100%",
  background: "#1e293b",
  display: "flex",
  flexDirection: "column",
  padding: "20px",
  gap: "20px",
  boxShadow:
    "0 5px 10px rgba(0,0,0,0.2)",
};

const mobileNavLink = {
  textDecoration: "none",
  fontSize: "18px",
  fontWeight: "500",
};

export default Header;


// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../../Images/statix tradinglogo.png";
// import { FaBars, FaTimes } from "react-icons/fa";

// const Header = () => {
//   const location = useLocation();

//   const [mobile, setMobile] = useState(
//     window.innerWidth <= 768
//   );

//   const [menuOpen, setMenuOpen] = useState(false);

//   useEffect(() => {
//     const handleResize = () => {
//       setMobile(window.innerWidth <= 768);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <header style={headerStyle}>
// <div
//   style={{
//     display: "flex",
//     alignItems: "center",
//     height: "60px",
//     minWidth: "140px", // ✅ prevents squeezing (main fix)
//   }}
// >
//   <img
//     src={logo}
//     alt="Statix Trading"
//     style={{
//       height: "55px",     // ✅ bigger logo
//       width: "auto",      // keep aspect ratio
//       minWidth: "120px",  // ✅ prevents “chhota lagna”
//       objectFit: "contain",
//       display: "block",
//     }}
//   />
// </div>

//       {/* Desktop Menu */}
//       {!mobile && (
//         <nav style={desktopMenu}>
//           <Link
//             to="/"
//             style={{
//               ...navLink,
//               color: location.pathname === "/" ? "#22c55e" : "#ffffff",
//             }}
//           >
//             Home
//           </Link>

//           <Link
//             to="/about"
//             style={{
//               ...navLink,
//               color: location.pathname === "/about" ? "#22c55e" : "#ffffff",
//             }}
//           >
//             About
//           </Link>

//           <Link
//             to="/contact"
//             style={{
//               ...navLink,
//               color: location.pathname === "/contact" ? "#22c55e" : "#ffffff",
//             }}
//           >
//             Contact
//           </Link>

//           <Link
//             to="/privacy-policy"
//             style={{
//               ...navLink,
//               color:
//                 location.pathname === "/privacy-policy"
//                   ? "#22c55e"
//                   : "#ffffff",
//             }}
//           >
//             Privacy Policy
//           </Link>
//         </nav>
//       )}

//       {/* Mobile Menu Icon */}
//       {mobile && (
//         <div style={menuIcon} onClick={() => setMenuOpen(!menuOpen)}>
//           {menuOpen ? (
//             <FaTimes size={24} color="#fff" />
//           ) : (
//             <FaBars size={24} color="#fff" />
//           )}
//         </div>
//       )}

//       {/* Mobile Menu */}
//       {mobile && menuOpen && (
//         <div style={mobileMenu}>
//           <Link
//             to="/"
//             style={{
//               ...mobileNavLink,
//               color: location.pathname === "/" ? "#22c55e" : "#ffffff",
//             }}
//             onClick={() => setMenuOpen(false)}
//           >
//             Home
//           </Link>

//           <Link
//             to="/about"
//             style={{
//               ...mobileNavLink,
//               color: location.pathname === "/about" ? "#22c55e" : "#ffffff",
//             }}
//             onClick={() => setMenuOpen(false)}
//           >
//             About
//           </Link>

//           <Link
//             to="/contact"
//             style={{
//               ...mobileNavLink,
//               color:
//                 location.pathname === "/contact" ? "#22c55e" : "#ffffff",
//             }}
//             onClick={() => setMenuOpen(false)}
//           >
//             Contact
//           </Link>

//           <Link
//             to="/privacy-policy"
//             style={{
//               ...mobileNavLink,
//               color:
//                 location.pathname === "/privacy-policy"
//                   ? "#22c55e"
//                   : "#ffffff",
//             }}
//             onClick={() => setMenuOpen(false)}
//           >
//             Privacy Policy
//           </Link>
//         </div>
//       )}
//     </header>
//   );
// };

// /* ================= Styles ================= */

// const headerStyle = {
//   background: "#0f172a",
//   padding: "8px 18px",   // ✅ reduced
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   position: "sticky",
//   top: 0,
//   zIndex: 1000,
//   height: "60px",        // ✅ fixed height
// };

// const desktopMenu = {
//   display: "flex",
//   gap: "25px",
//   alignItems: "center",
// };

// const navLink = {
//   textDecoration: "none",
//   fontSize: "16px",
//   fontWeight: "500",
//   transition: "0.3s",
// };

// const menuIcon = {
//   cursor: "pointer",
// };

// const mobileMenu = {
//   position: "absolute",
//   top: "60px", // ✅ adjusted
//   left: 0,
//   width: "100%",
//   background: "#1e293b",
//   display: "flex",
//   flexDirection: "column",
//   padding: "15px",
//   gap: "15px",
//   boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
// };

// const mobileNavLink = {
//   textDecoration: "none",
//   fontSize: "18px",
//   fontWeight: "500",
// };

// export default Header;